import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import axios from 'axios';
import configureStore from './configureStore';
import './styles.css';
import { BRAND, brandAsset } from './config/brand';
import { updateAuth, updateCustomerId } from './actions/user';
import { Loading } from './components';
import App from './containers/App';

// @cashew/utils errorHandler does `const { status } = resp.response;` and
// crashes when a request fails before reaching the server (DNS, CORS,
// network). Synthesize a response so the downstream destructure is safe.
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error && !error.response) {
      // eslint-disable-next-line no-param-reassign
      error.response = {
        status: 0,
        data: { message: error.message || 'Network error' },
      };
    }
    return Promise.reject(error);
  }
);

document.documentElement.dataset.brand = BRAND;
document.documentElement.style.setProperty(
  '--brand-logo-url',
  `url(${brandAsset('logo.svg')})`
);

const { api } = require('@cashew/utils');
// f provided by server, use it, else let the reducers handle initial state
// tslint:disable-next-line:no-any
const initialState = '{}';

const parsedInitialState = JSON.parse(initialState);
const { store, persistor } = configureStore(parsedInitialState);

const saveData = () => {
  const { token } = store.getState().user;
  if (!token) {
			store.dispatch(updateAuth(false));
			return Promise.resolve();
		}
  return api
    .get({
      endpoint: 'identity/validate',
      headers: {
        Authorization: token,
      },
    })
    .then((resp: any) => {
      store.dispatch(updateAuth(true));
      store.dispatch(updateCustomerId(resp.data.principalId));
      api.storeAuth(token);
    })
    .catch(() => {
      store.dispatch(updateAuth(false));
    });
};

if (initialState === '{}') {
  // Non-server rendered.
  ReactDOM.render(
    <Provider store={store}>
      {/* @ts-ignore */}
      <PersistGate
        loading={<Loading />}
        persistor={persistor}
        onBeforeLift={saveData}
      >
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </PersistGate>
    </Provider>,
    document.getElementById('root') as HTMLElement
  );
} else {
  // Server rendered hydration
  ReactDOM.hydrate(
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>,
    document.getElementById('root') as HTMLElement
  );
}
